import React, { Component } from "react";
import styles from "./css/HomePageCoverComp.module.css";

export class HomePageCoverComp extends Component {
  render() {
    return (
      <div className={styles.homePageCoverComp}>
        <div className={styles.coverImageCont}>
          <div className={styles.coverImage}>
            <img src="/assets/img/Home Page.png" />

            

            <p className={styles.coverImageTitle}>
              Help find your property management services
            </p>
             
          </div>
          <div className={styles.serviceSearchEngine}>
            <div className={styles.serviceSearchEngineInner}>
              
              <div className={`${styles.inputCont} ${styles.selectService}`}>
                <input type="text" value="" placeholder="Select a Service"/>
              </div>
              <div className={styles.inputCont}>
                <input type="text" placeholder="City" />
              </div>

              <div className={styles.inputCont}>
                <input type="text" placeholder="State" />
              </div>
              <div className={styles.inputCont}>
                <input type="text" placeholder="ZIP Code" />
              </div>
              
              <div className={styles.searchBtn}>
                <button>Search</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HomePageCoverComp;
